var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{key:_vm.$store.getters['resource/currentResource'].key,staticClass:"white-container"},[_c('trigger-view',{on:{"save":_vm.saveEvent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }